import { StyledHeaderForm } from "../../styled/HeaderForm";

const HeaderForm = ({ title }) => {

  return (
    <StyledHeaderForm.TitleContainer>
      <StyledHeaderForm.Text>{title}</StyledHeaderForm.Text>
    </StyledHeaderForm.TitleContainer>
  );
};
export default HeaderForm;
